import { isValidNumber } from 'libphonenumber-js';
import * as Yup from 'yup';

import AssetsCountryInterface from '@api/requests/assets/interfaces/AssetsCountryInterface.interface';

export const resetViaEmailFormValidationScheme = Yup.object().shape({
	email: Yup.string().email('Email address is invalid.').required('This field is required.'),
});

export const resetViaPhoneFormValidationScheme = (assetsCountries: AssetsCountryInterface[]) =>
	Yup.object().shape({
		phone: Yup.object().shape({
			code: Yup.string()
				.required('Required.')
				.test('oneOfRequired', 'Invalid code.', value => {
					if (!value) return true;

					return assetsCountries.map(({ dial_code }) => dial_code).includes(value);
				})
				.test('startsWithPlus', 'Code must start with "+".', value => value?.startsWith('+'))
				.min(2, 'Code must be at least 2 characters (including "+").')
				.max(5, 'Code must be at most 5 characters (including "+").'),
			number: Yup.string()
				.required('This field is required.')
				.min(7, 'Phone number must be at least 7 digits long.')
				.max(15, 'Phone number must be at most 15 digits long.')
				.test('validPhoneNumber', 'Phone number is not valid.', function (value) {
					const code = this.parent.code;
					if (!code || !value) return true;

					return isValidNumber(`${code}${value}`);
				}),
		}),
	});
